import _defineProperty from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["animation", "arrow", "children", "content", "placement", "style", "trigger", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx as _jsx } from "react/jsx-runtime";
import { Floating } from '../Floating';
import { useTheme } from '../Flowbite/ThemeContext';
/**
 * @see https://floating-ui.com/docs/react-dom-interactions
 */
export var Tooltip = function Tooltip(_ref) {
  var _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? 'duration-300' : _ref$animation,
    _ref$arrow = _ref.arrow,
    arrow = _ref$arrow === void 0 ? true : _ref$arrow,
    children = _ref.children,
    content = _ref.content,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? 'dark' : _ref$style,
    _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? 'hover' : _ref$trigger,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme().theme.tooltip;
  return _jsx(Floating, _objectSpread(_objectSpread({
    content: content,
    style: style,
    animation: animation,
    placement: placement,
    arrow: arrow,
    trigger: trigger,
    theme: theme,
    className: className
  }, props), {}, {
    children: children
  }));
};